var __t=window.__t=window.__t||(s=>(window.NL_I18N&&window.NL_I18N[s])||s);(() => {
  const requests = new WeakMap();
  function init(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach(root => { root.classList.add('nl-enhanced'); clamp(root); });
    scope.querySelectorAll('[data-product-recommendations]').forEach(async element => {
      if (element.dataset.loaded) return;
      element.dataset.loaded = 'true';
      try {
        const response = await fetch(element.dataset.url);
        if (!response.ok) throw new Error(__t("Recommendations unavailable"));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-product-recommendations]');
        if (content) element.innerHTML = content.innerHTML;
      } catch (_) { element.hidden = true; }
    });
  }
  // Long Etsy descriptions start collapsed with a Read more toggle.
  function clamp(root) {
    const copy = root.querySelector('[data-clamp]');
    const toggle = root.querySelector('[data-clamp-toggle]');
    if (!copy || !toggle) return;
    copy.classList.add('is-clamped');
    toggle.hidden = copy.scrollHeight <= copy.clientHeight + 4;
    if (toggle.hidden) copy.classList.remove('is-clamped');
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-clamp-toggle]');
    if (toggle) {
      const copy = toggle.closest('details').querySelector('[data-clamp]');
      const open = copy.classList.toggle('is-clamped') === false;
      toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
    }
    const thumb = event.target.closest('.pd-thumb');
    if (thumb) thumb.parentElement.querySelectorAll('.pd-thumb').forEach(button => button.classList.toggle('selected', button === thumb));
  });
  function markSelected(input) {
    const group = input.closest('.pd-swatches, .pd-chips');
    group?.querySelectorAll('label').forEach(label => label.classList.toggle('selected', label.contains(input)));
    const value = input.closest('[data-property-group]')?.querySelector('[data-property-value]');
    if (value) value.textContent = input.value;
  }
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-property-swatch]')) { markSelected(event.target); return; }
    if (!event.target.matches('[data-option-value]')) return;
    markSelected(event.target);
    const root = event.target.closest('[data-product-root]');
    requests.get(root)?.abort();
    const controller = new AbortController(); requests.set(root, controller);
    const url = new URL(root.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', [...root.querySelectorAll('[data-option-value]:checked')].map(input => input.value).join(','));
    const pageUrl = new URL(url); url.searchParams.set('section_id', root.dataset.sectionId);
    const form = root.querySelector('.main-product-form');
    const note = form.querySelector('[name="properties[Personalisation]"]')?.value;
    const quantity = form.querySelector('[name="quantity"]').value;
    const properties = [...form.querySelectorAll('[data-property-swatch]:checked')].map(input => [input.name, input.value]);
    const status = root.querySelector('.nl-product-status'); status.textContent = __t("Updating your options…");
    root.setAttribute('aria-busy', 'true'); root.classList.add('nl-variant-pending'); root.querySelector('[data-product-submit]').disabled = true;
    const focusId = event.target.value;
    try {
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) throw new Error(__t("Could not update options. Please try again."));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-product-root]');
      if (!fresh) throw new Error(__t("Could not update options. Please reload the page."));
      const freshNote = fresh.querySelector('[name="properties[Personalisation]"]');
      if (freshNote && note !== undefined) freshNote.value = note;
      const qty = fresh.querySelector('[name="quantity"]');
      const min = Number(qty.min) || 1, step = Number(qty.step) || 1;
      const max = qty.max ? Number(qty.max) : Infinity;
      qty.value = String(Math.min(max, min + Math.max(0, Math.floor((Number(quantity) - min) / step)) * step));
      properties.forEach(([name, value]) => {
        const input = [...fresh.querySelectorAll('[data-property-swatch]')].find(item => item.name === name && item.value === value);
        if (input) { input.checked = true; markSelected(input); }
      });
      fresh.classList.add('nl-enhanced'); root.replaceWith(fresh); clamp(fresh);
      document.dispatchEvent(new Event('nl:money'));
      history.replaceState({}, '', pageUrl);
      [...fresh.querySelectorAll('[data-option-value]')].find(input => input.value === focusId)?.focus({preventScroll:true});
    } catch (error) {
      if (error.name !== 'AbortError') { status.textContent = error.message; root.removeAttribute('aria-busy'); }
      // Keep purchase disabled after a failed refresh: the old variant must not be purchased as the new selection.
    }
  });
  const dialog = document.createElement('dialog');
  dialog.className = 'nl-image-dialog';
  const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close enlarged image');
  const img = document.createElement('img');
  dialog.append(close, img); document.body.append(dialog);
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  function zoom(target) {
    const photo = target.closest('[data-zoom-photo]')?.querySelector('img');
    if (!photo) return;
    img.src = photo.currentSrc || photo.src; img.alt = photo.alt; dialog.showModal();
  }
  document.addEventListener('click', event => zoom(event.target));
  document.addEventListener('keydown', event => {
    if (event.target.matches('[data-zoom-photo]') && ['Enter',' '].includes(event.key)) {event.preventDefault();zoom(event.target);}
  });
  // Looping clips in product info sections only load and play while their section is open.
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('toggle', event => {
    const video = event.target.matches?.('details') && event.target.querySelector(':scope > div > .nl-details-video video');
    if (!video) return;
    if (!event.target.open) { video.pause(); return; }
    if (reduceMotion.matches) { video.controls = true; return; }
    video.play().catch(() => { video.controls = true; });
  }, true);
  // Story section clips play only while on screen; reduced motion gets controls instead.
  const storyObserver = 'IntersectionObserver' in window && new IntersectionObserver(entries => entries.forEach(({target, isIntersecting}) => {
    if (!isIntersecting) { target.pause(); return; }
    target.play().catch(() => { target.controls = true; });
  }), {threshold: .35});
  function watchStoryVideos(scope = document) {
    scope.querySelectorAll('.nl-story-media video').forEach(video => {
      if (reduceMotion.matches || !storyObserver) { video.controls = true; return; }
      storyObserver.observe(video);
    });
  }
  watchStoryVideos(); document.addEventListener('shopify:section:load', event => watchStoryVideos(event.target));
  // Full process video: opens in a dialog with sound, stops when the dialog closes.
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-process-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.processOpen);
      dialog.showModal(); dialog.querySelector('video')?.play().catch(() => {});
      return;
    }
    const dialog = event.target.closest('.nl-process-dialog');
    if (dialog && (event.target === dialog || event.target.closest('[data-process-close]'))) dialog.close();
  });
  document.addEventListener('close', event => {
    if (event.target.matches?.('.nl-process-dialog')) event.target.querySelector('video')?.pause();
  }, true);
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
